exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader{min-height:80px;width:100%;background:rgba(0,0,0,.5) url(/src/assets/imgs/loading.gif) 50%/45px 45px no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/property-qc/handlers/DuplicatePropertyHandler.vue
// module id = 842
// module chunks = 0